import { deleteOfficeHierarchy } from "../../../../actions/OfficeHierarchy";
import { useMutation, useQueryClient } from "react-query";

const useDeleteOfficeHierarchy = () => {
  return useMutation(deleteOfficeHierarchy);
};
export default useDeleteOfficeHierarchy;
